import { WikiIndexEntry } from '../../../../api/help/model'
import { WikiIndexEntryVM } from './sidePanel.model'

const extractTitleAndSubtitleForSection = (section: string): string => section.split('/')[3] || ''

const extractTitleForSection = (section: string): string => {
  const titleAndSubtitle = extractTitleAndSubtitleForSection(section)
  const title = titleAndSubtitle.split('|')[0] || ''
  return title.trim()
}

const extractSubtitleForSection = (section: string): string => {
  const titleAndSubtitle = extractTitleAndSubtitleForSection(section)
  const subtitle = titleAndSubtitle.split('|')[1] || ''
  return subtitle.trim()
}

export const wikiIndexItemMapperToVM = (indexEntry: WikiIndexEntry): WikiIndexEntryVM => {
  return (
    indexEntry && {
      path: indexEntry.path,
      title: extractTitleForSection(indexEntry.path),
      subtitle: extractSubtitleForSection(indexEntry.path)
    }
  )
}
